var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMentorAndGrade = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1448,
  height: 1276,
  viewBox: "0 0 1448 1276",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_240_9)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M293.895 439.65C341.332 386.921 381.613 329.91 454.748 309.494C488.818 299.985 529.279 301.878 554.573 326.44C598.14 368.803 572.351 448.393 609.616 496.3C615.152 503.421 622.128 509.64 630.454 513.111C640.626 517.347 652.148 517.212 663.084 515.589C706.336 509.235 743.286 481.833 775.691 452.675C823.038 410.04 865.074 361.773 912.871 319.679C960.668 277.541 1015.89 241.036 1078.45 228.102C1113.6 220.846 1152.53 221.927 1182.33 241.757C1196.95 251.492 1208.61 265.237 1217.3 280.47C1238.54 317.696 1241.42 360.691 1234.89 402.244C1216.67 518.654 1179.31 625.825 1129.67 732.951C1118.69 756.657 1107.62 780.498 1092.45 801.77C1083 815.02 1071.47 827.504 1056.49 833.903C1041.46 840.303 1022.37 839.176 1010.76 827.774C1003.87 821.014 998.924 810.558 989.293 809.296C970.525 806.908 955.673 842.016 949.687 854.86C929.344 898.576 906.705 943.058 869.53 974.019C832.399 1004.98 776.906 1019.13 734.555 995.697C686.083 968.836 661.824 910.428 619.338 875.501C589.723 851.164 552.278 834.129 514.022 836.607C490.169 838.14 467.44 847.108 445.747 857.248C397.995 879.557 354.654 919.577 302.671 929.537C258.429 938.01 207.527 925.121 181.738 888.345C138.396 826.512 169.811 743.813 188.759 679.366C201.406 636.326 215.943 593.827 232.325 552.049C246.412 516.31 258.474 477.732 284.713 449.7C287.819 446.365 290.879 443.03 293.895 439.65Z",
  fill: "#E5E7EB"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1045.96 986.591H474.057V1007.01H1045.96V986.591Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1033.13 979.246V986.592H1002.71V979.246C1002.71 977.218 1004.33 975.595 1006.35 975.595H1029.44C1031.51 975.55 1033.13 977.218 1033.13 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M986.233 979.246V986.592H955.809V979.246C955.809 977.218 957.429 975.595 959.454 975.595H982.542C984.568 975.55 986.233 977.218 986.233 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M938.481 979.246V986.592H908.057V979.246C908.057 977.218 909.722 975.595 911.702 975.595H934.791C936.816 975.55 938.481 977.218 938.481 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M891.539 979.246V986.592H861.114V979.246C861.114 977.218 862.779 975.595 864.76 975.595H887.848C889.918 975.55 891.539 977.218 891.539 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M842.076 979.246V986.592H811.651V979.246C811.651 977.218 813.317 975.595 815.297 975.595H838.386C840.456 975.55 842.076 977.218 842.076 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M795.134 979.246V986.592H764.71V979.246C764.71 977.218 766.375 975.595 768.355 975.595H791.444C793.514 975.55 795.134 977.218 795.134 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M747.382 979.246V986.592H716.957V979.246C716.957 977.218 718.577 975.595 720.603 975.595H743.691C745.761 975.55 747.382 977.218 747.382 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M700.485 979.246V986.592H670.061V979.246C670.061 977.218 671.681 975.595 673.706 975.595H696.794C698.82 975.55 700.485 977.218 700.485 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M657.279 979.246V986.592H626.854V979.246C626.854 977.218 628.52 975.595 630.5 975.595H653.588C655.659 975.55 657.279 977.218 657.279 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M610.381 979.246V986.592H579.956V979.246C579.956 977.218 581.621 975.595 583.602 975.595H606.69C608.715 975.55 610.381 977.218 610.381 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M562.63 979.246V986.592H532.205V979.246C532.205 977.218 533.825 975.595 535.851 975.595H558.939C560.964 975.55 562.63 977.218 562.63 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M515.687 979.246V986.592H485.263V979.246C485.263 977.218 486.883 975.595 488.908 975.595H511.997C514.067 975.55 515.687 977.218 515.687 979.246Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M788.473 791.404L889.603 824.844V791.404H788.473Z",
  fill: "#231F20"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M889.603 776.037H667.45V966.764H889.603V776.037Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M1120.35 791.403H398.761C393.855 791.403 389.895 787.437 389.895 782.525V292.637C389.895 287.725 393.855 283.759 398.761 283.759H1120.35C1125.26 283.759 1129.22 287.725 1129.22 292.637V782.525C1129.22 787.437 1125.21 791.403 1120.35 791.403Z",
  fill: "white"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M1117.52 300.434H401.641V776.035H1117.52V300.434Z",
  fill: "#E5E7EB"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M913.007 342.663H457.449V437.396H913.007V342.663Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M913.007 489.541H457.449V584.273H913.007V489.541Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M913.007 641.644H457.449V736.377H913.007V641.644Z",
  stroke: "white",
  strokeWidth: 4.3338,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M536.724 1017.5L228.04 1004.81C224.069 984.232 249.849 859.157 254.536 838.591C260.78 811.26 245.585 823.3 257.124 797.796C259.696 792.089 251.965 844.298 254.536 838.591C261.56 823.141 268.537 807.688 275.561 792.239L514.943 814.172L517.549 860.535L520.974 920.994L536.724 1017.5Z",
  fill: "#D6DAE0"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M576.853 492.651L465.371 617.804L518.704 669.633L626.225 531.815L576.853 492.651Z",
  fill: "#B47668"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M596.385 429.374C598.276 424.912 603.181 420.676 606.422 417.161C610.427 412.789 614.568 408.553 618.844 404.406C622.894 400.486 627.08 396.61 632.031 393.861C633.381 393.14 634.776 392.464 636.306 392.373C637.837 392.283 639.457 392.914 640.222 394.221C641.077 395.663 640.627 397.511 640.042 399.088C638.512 403.054 636.126 406.615 633.741 410.13C628.655 417.566 623.569 425.002 618.484 432.439C632.256 417.747 646.928 403.1 663.31 391.382C666.821 388.858 670.781 390.526 671.231 395.123C671.636 399.404 668.531 403.64 665.966 406.795C657.774 416.89 649.628 427.031 641.437 437.126C649.583 429.96 657.729 422.749 665.876 415.583C671.816 410.355 677.937 404.992 685.409 402.378C687.029 401.793 688.829 401.387 690.404 402.018C692.565 402.919 693.51 405.623 693.15 407.922C692.79 410.22 691.394 412.248 690.044 414.141C687.794 417.296 685.499 420.451 683.113 423.515C681.178 425.994 678.883 427.481 676.767 429.69C671.096 435.638 666.641 443.12 661.195 449.384C669.656 442.489 678.117 435.593 686.579 428.698C689.414 426.4 692.295 424.056 695.58 422.479C705.256 417.927 705.706 427.121 701.476 433.205C697.29 439.289 692.069 444.652 686.804 449.79C679.918 456.505 672.717 462.905 666.641 470.386C660.295 478.137 657.189 487.286 651.654 495.534C643.327 507.972 634.956 520.411 626.63 532.85C626.585 532.895 626.585 532.94 626.54 532.985L557.77 520.051C557.68 520.141 596.385 429.374 596.385 429.374Z",
  fill: "#B47668"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M661.825 507.072C666.461 502.881 670.691 498.194 674.292 492.695C679.423 484.899 684.553 477.147 689.639 469.35C691.89 465.925 694.23 462.184 693.96 458.083C693.87 457.002 693.6 455.875 692.745 455.199C691.664 454.343 690.134 454.523 688.829 454.883C682.258 456.641 677.082 461.689 672.672 466.917C668.711 471.604 664.66 478.229 659.17 481.248C653.364 484.403 647.018 486.296 641.347 490.036C635.226 494.092 630.095 499.591 625.955 505.72C623.074 509.956 613.173 528.93 622.579 531.228C626.36 532.13 630.995 528.66 633.921 526.812C643.867 520.502 653.499 514.598 661.825 507.072Z",
  fill: "#B47668"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M477.207 343.521C472.481 341.492 472.391 333.921 471.806 329.685C470.861 322.609 469.826 315.398 467.845 308.503C464.65 297.641 459.789 287.096 452.273 278.623C360.55 215.032 276.342 339.555 349.658 388.183L441.922 424.507C443.947 424.688 471.536 433.791 477.252 411.798C478.377 407.562 479.547 403.371 479.637 398.999C479.817 390.571 479.592 382.099 478.917 373.716C478.647 370.246 478.827 362.719 478.827 362.719C490.079 356.635 488.503 350.822 477.207 343.521Z",
  fill: "#B47668"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M459.09 343.993C461.34 343.899 463.025 340.498 462.854 336.396C462.683 332.294 460.721 329.045 458.471 329.138C456.221 329.232 454.536 332.633 454.707 336.735C454.878 340.837 456.84 344.087 459.09 343.993Z",
  fill: "#28355C"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M738.066 628.035L715.383 665.576C702.421 687.029 674.112 693.068 653.544 678.781L610.878 649.126L512.763 580.939L460.78 478.59C490.98 472.28 519.424 460.743 566.231 504.819L662.86 574.089L738.066 628.035Z",
  fill: "#B47668"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M654.534 601.399L767.906 436.811L806.072 481.428L738.067 628.034L654.534 601.399Z",
  fill: "#B47668"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M662.86 574.089L610.878 649.126L583.289 688.966L492.24 623.934L460.78 478.59C490.98 472.28 519.424 460.743 566.231 504.819L662.86 574.089Z",
  fill: "#6D993E"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M447.053 414.143L446.197 419.461L443.677 435.235L436.026 482.826H436.206C436.161 482.871 436.071 482.917 436.026 482.962L435.486 486.432L430.895 486.928C418.428 496.031 404.611 503.332 389.984 508.335C378.507 512.256 366.04 514.825 354.339 511.76C346.282 509.642 338.766 504.189 334.761 497.023H334.941L334.221 497.113C354.879 476.787 360.415 438.074 362.53 395.305L447.053 414.143Z",
  fill: "#B47668"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M445.298 425.273L443.677 435.278L419.959 414.546L445.298 425.273Z",
  fill: "#935143"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M805.171 345.278L906.076 437.396L916.743 426.985L815.658 334.506C813.678 332.704 810.617 332.659 808.592 334.416L805.216 337.346C802.876 339.419 802.831 343.114 805.171 345.278Z",
  fill: "#62A8C7"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M916.743 426.987L925.249 443.482L922.864 445.87L906.076 437.397L916.743 426.987Z",
  fill: "#62A8C7"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M922.684 445.373L924.484 446.32C925.114 446.68 925.879 446.004 925.564 445.328L924.574 443.03L922.684 445.373Z",
  fill: "#EA2F2F"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M882.178 447.717L858.369 458.804C856.209 459.796 853.734 459.841 851.618 458.804C847.163 456.641 847.568 451.503 853.779 446.501L876.057 434.783L882.178 447.717Z",
  fill: "#C96959"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M908.147 402.693C910.128 404.541 911.028 407.47 910.443 410.129C909.903 412.788 907.877 415.087 905.312 415.988C904.412 416.304 903.467 416.484 902.521 416.349C901.216 416.168 900.091 415.492 898.966 414.861C893.07 411.436 887.039 408.191 880.513 406.253C873.987 404.315 866.876 403.775 860.395 405.803C861.745 405.397 865.616 407.065 867.281 407.11C869.577 407.2 871.467 407.155 873.762 407.65C878.668 408.732 883.484 410.174 888.119 412.157C892.395 414.005 894.735 416.258 895.185 419.008C895.545 421.036 894.78 423.244 893.16 425.092C892.71 425.588 892.215 426.083 891.675 426.489C890.505 427.435 889.2 428.201 887.984 428.877C883.934 431.131 879.703 433.024 875.382 434.511L876.058 434.736C878.038 435.457 880.063 436.178 881.728 437.53C883.664 439.063 884.744 441.136 884.609 443.164C884.519 444.831 883.619 446.454 882.133 447.671C881.908 447.851 881.683 448.031 881.413 448.212C879.973 449.158 878.173 449.699 875.743 450.014C869.577 450.78 863.186 449.473 857.56 448.347C853.644 447.536 849.639 446.769 845.768 445.958C834.876 458.172 824.12 468.943 813.813 476.244C811.068 478.182 808.412 479.849 805.712 481.246L767.861 436.719C767.816 436.674 767.771 436.674 767.771 436.674C769.662 434.511 771.507 432.438 773.352 430.41C808.638 390.75 829.026 371.957 835.552 372.993C837.487 373.309 839.062 372.362 840.817 371.957C843.653 371.326 846.713 371.191 849.549 370.875C855.399 370.289 861.295 369.884 867.191 369.748C869.757 369.703 872.322 369.658 874.842 370.154C878.353 370.875 881.593 372.543 884.744 374.345C890.37 377.545 895.77 381.106 901.036 384.891C902.206 385.748 903.422 386.604 904.592 387.505C907.157 389.398 909.813 391.516 910.983 394.491C911.253 395.257 911.433 396.068 911.433 396.879C911.568 399.448 910.443 401.927 908.147 402.693Z",
  fill: "#B47668"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M904.501 409.545C905.626 409.996 906.796 410.356 908.011 410.311C909.182 410.221 910.307 409.635 910.622 408.644C910.757 408.238 910.712 407.787 910.622 407.337C909.947 403.371 903.781 396.746 898.605 398.098C895.95 398.774 896.085 401.658 897.12 403.641C898.515 406.345 901.53 408.328 904.501 409.545Z",
  fill: "#E57070"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M911.523 396.971C911.208 397.061 910.848 397.152 910.533 397.152C909.363 397.242 908.147 396.836 907.022 396.385C904.052 395.169 901.081 393.186 899.641 390.527C898.561 388.544 898.471 385.659 901.126 384.983C902.297 385.84 903.512 386.696 904.682 387.597C907.247 389.49 909.903 391.608 911.073 394.583C911.343 395.349 911.523 396.16 911.523 396.971Z",
  fill: "#E57070"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M522.191 580.889C547.359 485.479 515.781 462.693 454.995 477.207C452.665 477.751 450.337 478.386 447.92 479.022L432.44 481.507L334.311 491.759L322.875 493.618C322.872 493.619 322.871 493.619 322.867 493.619C322.757 493.637 319.235 494.19 319.19 494.191C290.789 498.747 278.963 551.94 272 580.889C263.183 617.625 256.56 828.611 247.069 872.319C246.791 873.599 247.777 874.723 249.086 874.723L522.158 874.724C523.294 874.724 524.203 873.809 524.159 872.674C523.415 853.387 517.849 703.984 523.126 680.311C526.667 664.37 535.028 652.927 534.985 635.663C534.953 621.059 519.103 592.628 522.191 580.889Z",
  fill: "#6D993E"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.22
}, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M324.251 634.614L449.168 584.085L485.845 610.147L535.812 655.89L516.675 680.888V825.029L348.703 793.648L324.251 634.614Z",
  fill: "url(#paint0_linear_240_9)"
}))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M329.586 503.69L336.472 472.413L448.674 461.642V488.142L329.586 503.69Z",
  fill: "#6D993E"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M364.465 419.955C366.446 418.423 368.021 416.35 369.506 414.322C379.318 400.756 384.223 384.036 395.97 371.958C399.931 367.902 404.566 364.161 408.122 359.745C411.227 355.869 412.758 351.362 414.963 346.81C420.184 348.613 426.26 346.269 429.68 341.943C433.146 337.661 434.181 331.758 433.506 326.304C432.426 317.877 427.565 310.125 427.385 301.607C437.016 308.277 450.788 306.249 460.285 299.309C462.94 297.371 465.37 295.027 466.721 292.053C469.916 284.977 465.73 276.324 459.385 271.862C453.039 267.446 445.027 266.184 437.376 265.012C426.62 263.39 417.303 258.793 406.592 257.576C394.08 256.179 381.298 257.351 369.146 260.415C364.42 261.632 359.695 263.119 355.374 265.418C350.558 267.987 346.283 271.592 342.862 275.873C342.097 276.865 341.332 277.902 340.297 278.623C339.127 279.434 337.641 279.659 336.291 280.11C323.554 284.211 315.003 295.568 310.862 307.736C307.442 317.741 306.002 328.378 305.957 338.923C305.867 357.987 314.778 374.482 325.355 389.625C329.81 396.024 336.111 400.621 341.827 405.849C346.418 410.04 349.883 418.378 355.194 421.307C357.759 422.75 361.045 422.164 363.52 420.631C363.835 420.406 364.15 420.181 364.465 419.955Z",
  fill: "#28355C"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M1069.67 342.663H966.475V437.396H1069.67V342.663Z",
  fill: "#F4F5F7"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M1069.67 489.541H966.475V584.273H1069.67V489.541Z",
  fill: "#F4F5F7"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M1069.67 641.644H966.475V736.377H1069.67V641.644Z",
  fill: "#F4F5F7"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M983.037 364.7L1018.05 420.269L1053.11 322.066",
  stroke: "#28355C",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M983.037 509.956L1018.05 565.57L1053.11 467.322",
  stroke: "#28355C",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M983.037 653.904L1053.11 719.793",
  stroke: "#EA2F2F",
  strokeWidth: 7,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M1050.95 651.785L985.152 721.955",
  stroke: "#EA2F2F",
  strokeWidth: 7,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.4
}, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M381.623 1010.6L381.623 932.418L300.776 842.464L232.337 949.913L219.994 1010.6L381.623 1010.6Z",
  fill: "url(#paint1_linear_240_9)"
}))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M467.832 373.821C472.141 374.687 476.63 375.446 479.191 375.762C480.313 375.952 480.793 377.245 480.017 378.306C477.867 381.382 473.129 386.581 465.675 385.379C458.222 384.177 455.558 377.14 454.796 372.985C454.585 371.777 455.678 370.652 456.754 370.99C459.443 371.836 463.658 372.998 467.832 373.821Z",
  fill: "white"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M369.161 409.986C370.211 406.468 370.472 402.696 371.505 398.767C372.631 394.497 366.331 391.357 367.451 387.145C368.657 382.649 368.249 377.992 369.571 373.508C373.842 375.63 378.859 370.872 378.987 366.094C379.116 361.315 376.166 357.047 373.469 353.154C370.779 349.204 368.083 344.727 368.793 339.949C369.718 334.198 373.079 330.853 371.243 324.767C369.936 320.371 366.87 316.676 365.679 311.706C371.5 313.457 377.501 314.583 383.525 314.893C387.865 315.152 392.857 314.716 395.585 311.308C396.715 309.902 397.373 307.981 398.964 307.205C400.804 306.279 402.982 307.198 404.896 307.856C412.037 310.382 418.747 309.066 425.717 306.9C431.482 305.139 432.193 301.529 437.151 299.103C438.679 298.379 440.454 298.674 442.143 298.667C446.795 298.723 451.425 296.089 453.813 292.004C456.195 287.977 456.203 282.66 453.875 278.571C452.982 277.021 451.836 275.679 451.248 273.984C450.045 270.3 452.139 266.243 451.592 262.391C451.161 259.134 448.816 256.387 445.952 254.756C443.087 253.126 439.767 252.56 436.528 252.353C434.62 252.221 432.585 252.193 431.064 251.106C428.943 249.608 428.483 246.64 427.192 244.408C423.367 237.831 410.391 237.761 404.441 240.789C402.354 241.866 400.463 243.313 398.272 244.262C390.356 247.736 381.048 243.592 372.591 245.492C368.423 246.42 364.566 248.897 361.953 252.317C360.679 254.001 359.663 256.003 358.118 257.485C353.857 261.675 347.32 261.255 342.275 263.964C336.677 266.969 331.965 272.75 329.582 278.53C328.503 281.169 327.741 284.131 325.735 286.151C323.918 288.014 321.272 288.86 318.897 289.908C306.663 295.229 297.942 307.913 297.367 321.237C296.89 331.824 301.112 342.004 305.571 351.566C316.255 374.546 337.928 395.118 351.779 416.136C353.092 418.137 354.573 420.213 356.815 421.08C362.36 423.271 367.937 414.07 369.161 409.986Z",
  fill: "#28355C"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  d: "M392.291 380.373C407.85 380.373 420.463 367.752 420.463 352.183C420.463 336.614 407.85 323.993 392.291 323.993C376.731 323.993 364.118 336.614 364.118 352.183C364.118 367.752 376.731 380.373 392.291 380.373Z",
  fill: "#B47668"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M403.605 359.301C404.507 358.025 404.332 356.38 403.091 355.343C398.139 351.403 393.058 347.427 388.105 343.488C386.958 342.614 385.061 342.713 384.16 343.989C383.258 345.266 383.433 346.91 384.674 347.948C389.626 351.888 394.707 355.863 399.66 359.803C400.854 360.759 402.704 360.578 403.605 359.301Z",
  fill: "#935143"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_240_9",
  x1: 505.305,
  y1: 587.084,
  x2: 448.513,
  y2: 678.449,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#618334"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_240_9",
  x1: 401.415,
  y1: 1017.88,
  x2: 265.381,
  y2: 862.344,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A09FA3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_240_9"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1078,
  height: 784,
  fill: "white",
  transform: "translate(160 224)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMentorAndGrade);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mentorAndGrade.afabe8abd3ca9c764f544bdfce744072.svg";